import {
    TInput,
    TCard,
    TTextarea,
    TSelect,
    TRadio,
    TCheckbox,
    TButton,
    TInputGroup,
    TAlert,
    TModal,
    TDropdown,
    TRichSelect,
    TPagination,
    TTag,
    TRadioGroup,
    TCheckboxGroup,
    TTable,
    TDatepicker,
    TToggle,
    TDialog,
    TBadge,
} from 'vue-tailwind/dist/components';

export default {
    't-card': {
        component: TCard,
        props: {
            fixedClasses: {
                wrapper: 'border rounded shadow-sm ',
                body: 'md:p-3',
                header: 'border-b p-3 rounded-t',
                footer: 'border-t p-3 rounded-b',
            },
            classes: {
                wrapper: 'bg-white border-gray-100',
                body: '',
                header: 'border-gray-100',
                footer: 'border-gray-100',
            },
            variants: {
                danger: {
                    wrapper: 'bg-red-50 text-red-700 border-red-200',
                    header: 'border-red-200 text-red-700',
                    footer: 'border-red-200 text-red-700',
                },
            },
        },
    },
    't-input': {
        component: TInput,
        props: {
            fixedClasses:
                'block w-full px-3 py-2.5 transition duration-100 ease-in-out border rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed',
            classes:
                'border border-gray-300 text-gray-900 text-md rounded-md block w-80 p-2.5 focus:border-green-500 focus:ring-1 focus:ring-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-green-500 dark:focus:ring-1 dark:focus:ring-green-500',
            variants: {
                danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
                success: 'border-gray-300 bg-gray-50 placeholder-gray-400 text-gray-900',
            },
        },
    },
    't-textarea': {
        component: TTextarea,
        props: {
            fixedClasses:
                'block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-green-500 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed',
            classes:
                'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-indigo-500 focus:ring-indigo-500',
            variants: {
                danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
                success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
            },
        },
    },
    't-select': {
        component: TSelect,
        props: {
            fixedClasses:
                'block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded focus:ring-1 focus:ring-green-500 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed',
            classes:
                'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-indigo-500 focus:ring-indigo-500',
            variants: {
                danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
                success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
            },
        },
    },
    't-radio': {
        component: TRadio,
    },
    't-checkbox': {
        component: TCheckbox,
    },
    't-button': {
        component: TButton,
        props: {
            fixedClasses:
                'block justify-center transition duration-100 ease-in-out focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
            classes:
                'text-white font-semibold text-md bg-indigo-500 border border-transparent shadow-sm rounded-sm hover:bg-indigo-600 focus:border-indigo-500 ',
            variants: {
                secondary:
                    'text-gray-800 px-4 py-2 text-sm bg-white border border-gray-300 shadow-sm hover:text-gray-600',
                primary:
                    'text-white text-sm bg-blue-500 border border-transparent rounded-sm shadow-sm hover:bg-blue-600 focus:border-indigo-500 focus:ring-indigo-500',
                success:
                    'text-white text-md px-4 py-2 bg-green-500 border border-transparent rounded-md shadow-sm hover:bg-green-600 focus:border-green-500 focus:ring-green-500',
                warn: 'text-white text-md px-4 py-2 bg-yellow-600 border border-transparent rounded-md shadow-sm hover:bg-yellow-500 focus:border-yellow-500 focus:ring-yellow-500',
                error: 'text-white text-md bg-red-500 border border-transparent rounded-md shadow-sm hover:bg-red-600 focus:border-red-500 focus:ring-red-500',
                link: 'text-blue-500 text-sm underline hover:text-blue-600',
                text: 'text-blue-500 text-sm underline-none hover:text-blue-600',
                outline:
                    'text-gray-800 text-md px-4 py-2 bg-white border border-green-300 rounded-md shadow-sm hover:text-gray-600 hover:bg-green-100 focus:border-green-500 focus:ring-green-500',
                group: 'text-white text-md px-4 py-2 bg-green-500 border border-transparent shadow-sm hover:bg-green-600 focus:border-green-500 focus:ring-green-500',
                groupwarn:
                    'text-white text-md px-4 py-2 bg-red-500 border border-transparent shadow-sm hover:bg-red-600 focus:border-red-500 focus:ring-red-500',
                groupoutline:
                    'text-gray-800 text-md px-2 py-2 bg-white border border-green-500 shadow-sm hover:text-gray-600 hover:bg-green-100 focus:border-green-500 focus:ring-green-500',
            },
        },
    },
    't-input-group': {
        component: TInputGroup,
    },
    't-alert': {
        component: TAlert,
    },
    't-modal': {
        component: TModal,
        props: {
            fixedClasses: {
                overlay:
                    'z-40 overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50',
                wrapper: 'relative mx-auto z-50 max-w-2xl max-w-md px-3 py-12',
                modal: 'overflow-visible relative  rounded',
                body: 'p-3',
                header: 'border-b p-3 rounded-t',
                footer: 'pb-3 rounded-b',
                close: 'flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50',
            },
            classes: {
                overlay: 'bg-black',
                wrapper: '',
                modal: 'bg-white shadow',
                body: 'min-h-md',
                header: 'border-gray-100 font-semibold text-base',
                footer: 'bg-gray-100',
                close: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                closeIcon: 'fill-current h-4 w-4',
                overlayEnterClass: 'opacity-0',
                overlayEnterActiveClass: 'transition ease-out duration-100',
                overlayEnterToClass: 'opacity-100',
                overlayLeaveClass: 'opacity-100',
                overlayLeaveActiveClass: 'transition ease-in duration-75',
                overlayLeaveToClass: 'opacity-0',
                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: '',
            },
            variants: {
                danger: {
                    overlay: 'bg-red-100',
                    header: 'border-red-50 text-red-700',
                    close: 'bg-red-50 text-red-700 hover:bg-red-200 border-red-100 border',
                    modal: 'bg-white border border-red-100 shadow-lg',
                    footer: 'bg-red-50',
                },
            },
        },
    },
    't-dropdown': {
        component: TDropdown,
        props: {
            fixedClasses: {
                button: 'flex items-center text-white block px-4 py-2 transition duration-100 ease-in-out border border-transparent rounded shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
                wrapper: 'inline-flex flex-col',
                dropdownWrapper: 'relative z-10',
                dropdown: 'origin-top-left absolute left-0 w-56 rounded shadow mt-1',
                enterClass: 'opacity-0 scale-95',
                enterActiveClass: 'transition transform ease-out duration-100',
                enterToClass: 'opacity-100 scale-100',
                leaveClass: 'opacity-100 scale-100',
                leaveActiveClass: 'transition transform ease-in duration-75',
                leaveToClass: 'opacity-0 scale-95',
            },
            classes: {
                button: 'bg-green-500 hover:bg-green-600',
                dropdown: 'bg-white',
            },
            variants: {
                danger: {
                    button: 'bg-red-500 hover:bg-red-600',
                    dropdown: 'bg-red-50',
                },
                categoryDropdown: {
                    button: 'bg-transparent hover:bg-green-500',
                    dropdown:
                        'origin-top-left bg-green-50 overflow-scroll h-96 absolute left-0 w-56 rounded shadow mt-1',
                },
            },
        },
    },
    't-rich-select': {
        component: TRichSelect,
        props: {
            fixedClasses: {
                wrapper: 'relative',
                buttonWrapper: 'inline-block relative w-full',
                selectButton:
                    'w-full flex text-left justify-between items-center px-3 py-2 text-black transition duration-100 ease-in-out border rounded shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
                selectButtonLabel: 'block truncate',
                selectButtonPlaceholder: 'block truncate',
                selectButtonIcon: 'fill-current flex-shrink-0 ml-1 h-4 w-4',
                selectButtonClearButton:
                    'rounded flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6 transition duration-100 ease-in-out',
                selectButtonClearIcon: 'fill-current h-3 w-3',
                dropdown: 'absolute w-full z-10 -mt-1 absolute border-b border-l border-r rounded-b shadow-sm z-10',
                dropdownFeedback: '',
                loadingMoreResults: '',
                optionsList: 'overflow-auto',
                searchWrapper: 'inline-block w-full',
                searchBox: 'inline-block w-full',
                optgroup: '',
                option: 'cursor-pointer',
                disabledOption: 'opacity-50 cursor-not-allowed',
                highlightedOption: 'cursor-pointer',
                selectedOption: 'cursor-pointer',
                selectedHighlightedOption: 'cursor-pointer',
                optionContent: '',
                optionLabel: 'truncate block',
                selectedIcon: 'fill-current h-4 w-4',
                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: '',
            },
            classes: {
                wrapper: '',
                buttonWrapper: '',
                selectButton: 'bg-white border-gray-300',
                selectButtonLabel: '',
                selectButtonPlaceholder: 'text-gray-400',
                selectButtonIcon: 'text-gray-600',
                selectButtonClearButton: 'hover:bg-green-100 text-gray-600',
                selectButtonClearIcon: '',
                dropdown: 'bg-white border-gray-300',
                dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
                loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
                optionsList: '',
                searchWrapper: 'p-2 placeholder-gray-400',
                searchBox:
                    'px-3 py-2 bg-gray-50 text-sm rounded border focus:outline-none focus:shadow-outline border-gray-300',
                optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
                option: '',
                disabledOption: '',
                highlightedOption: 'bg-green-100',
                selectedOption: 'font-semibold bg-gray-100 bg-green-500 font-semibold text-white',
                selectedHighlightedOption: 'font-semibold bg-gray-100 bg-green-600 font-semibold text-white',
                optionContent: 'flex justify-between items-center px-3 py-2',
                optionLabel: '',
                selectedIcon: '',
                enterClass: 'opacity-0',
                enterActiveClass: 'transition ease-out duration-100',
                enterToClass: 'opacity-100',
                leaveClass: 'opacity-100',
                leaveActiveClass: 'transition ease-in duration-75',
                leaveToClass: 'opacity-0',
            },
            variants: {
                danger: {
                    selectButton: 'border-red-300 bg-red-50 text-red-900',
                    selectButtonPlaceholder: 'text-red-200',
                    selectButtonIcon: 'text-red-500',
                    selectButtonClearButton: 'hover:bg-red-200 text-red-500',
                    dropdown: 'bg-red-50 border-red-300',
                },
                success: {
                    selectButton: 'border-green-300 bg-green-50 text-green-900',
                    selectButtonIcon: 'text-green-500',
                    selectButtonClearButton: 'hover:bg-green-200 text-green-500',
                    dropdown: 'bg-green-50 border-green-300',
                },
            },
        },
    },
    't-pagination': {
        component: TPagination,
        props: {
            classes: {
                wrapper: 'table border-collapse text-center bg-white dark:bg-gray-900 mx-auto shadow-sm',
                element: 'w-8 h-8 border border-gray-200 table-cell hover:border-green-100',
                activeElement: 'w-8 h-8 border border-gray-200 border-green-500 table-cell hover:border-green-600',
                disabledElement: 'w-8 h-8 border border-gray-200 table-cell',
                ellipsisElement: 'w-8 h-8 border border-gray-200 hidden md:table-cell',
                activeButton:
                    'bg-green-500 w-full h-full text-white hover:bg-green-600 transition duration-100 ease-in-out focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50',
                disabledButton: 'opacity-25 w-full h-full cursor-not-allowed transition duration-100 ease-in-out',
                button: 'hover:bg-green-100 w-full h-full transition duration-100 ease-in-out focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50',
                ellipsis: '',
            },
            variants: {
                rounded: {
                    wrapper: 'bg-gray-100 dark:bg-gray-900 mx-auto text-center flex space-x-2',
                    element: 'w-8 h-8 rounded-full',
                    activeElement: 'w-8 h-8 rounded-full',
                    disabledElement: 'w-8 h-8 rounded-full',
                    ellipsisElement: 'w-8 h-8 rounded-full hidden md:inline',
                    activeButton:
                        'border border-green-500 bg-green-500 w-full h-full rounded-full text-white hover:bg-green-600 transition duration-100 ease-in-out focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50',
                    disabledButton:
                        'border border-gray-200 bg-green-500 opacity-25 w-full h-full rounded-full cursor-not-allowed transition duration-100 ease-in-out',
                    button: 'border border-gray-200 hover:bg-green-100 hover:border-green-100 rounded-full w-full h-full transition duration-100 ease-in-out focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50',
                    ellipsis: '',
                },
            },
        },
    },
    't-tag': {
        component: TTag,
    },
    't-radio-group': {
        component: TRadioGroup,
        props: {
            classes: {
                groupWrapper: 'flex flex-col',
                label: 'ml-2 text-gray-700 uppercase text-sm',
                input: 'text-green-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-green-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
            },
            variants: {
                danger: {
                    groupWrapper: 'flex flex-col',
                    label: 'ml-2 text-red-500 uppercase text-sm',
                    input: 'text-red-500 transition duration-100 ease-in-out border-red-500 shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
                },
                buttons: {
                    groupWrapper: 'flex',
                    label: '',
                    labelChecked: '',
                    wrapper:
                        'mx-1 bg-white border border-gray-300 flex items-center px-4 py-2 rounded shadow-sm cursor-pointer focus:shadow-outline text-sm text-gray-700 hover:text-gray-500 leading-5 uppercase',
                    wrapperChecked:
                        'mx-1 bg-gray-100 border border-gray-300 flex items-center px-4 py-2 rounded shadow-inner cursor-pointer focus:shadow-outline text-sm text-gray-700 hover:text-gray-500 leading-5 uppercase',
                    inputWrapper: '',
                    inputWrapperChecked: '',
                    input: 'absolute invisible',
                },
            },
        },
    },
    't-checkbox-group': {
        component: TCheckboxGroup,
    },
    't-table': {
        component: TTable,
    },
    't-datepicker': {
        component: TDatepicker,
    },
    't-toggle': {
        component: TToggle,
        // props: {
        //     fixedClasses: {
        //         wrapper: 'flex items-center',
        //         input: 'sr-only',
        //         track: 'w-10 h-6 bg-gray-300 rounded-full shadow-inner transition duration-200 ease-in-out',
        //         thumb: 'dot w-4 h-4 bg-white rounded-full shadow transform transition duration-200 ease-in-out',
        //     },
        //     classes: {
        //         // default state
        //         trackChecked: 'bg-green-500',
        //         thumbChecked: 'translate-x-4',

        //         // when unchecked
        //         trackUnchecked: 'bg-gray-300',
        //         thumbUnchecked: 'translate-x-0',

        //         // focus/hover etc.
        //         trackFocus: 'ring-2 ring-green-400',
        //         trackHover: 'hover:bg-green-400',
        //     },
        //     variants: {
        //         danger: {
        //             trackChecked: 'bg-red-500',
        //             thumbChecked: 'translate-x-4',
        //         },
        //         success: {
        //             trackChecked: 'bg-green-600',
        //             thumbChecked: 'translate-x-4',
        //         },
        //     },
        // },
    },
    't-dialog': {
        component: TDialog,
        props: {
            fixedClasses: {
                overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed',
                wrapper: 'relative mx-auto',
                modal: 'overflow-visible relative ',
                close: 'flex items-center justify-center',
                dialog: 'overflow-visible relative',
            },
            classes: {
                close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50',
                closeIcon: 'fill-current h-4 w-4',

                overlay: 'z-50 bg-black bg-opacity-50',
                wrapper: 'z-200 max-w-lg px-3 py-12',
                dialog: 'bg-white shadow rounded text-left',

                body: 'p-3 space-y-3',
                buttons: 'p-3 flex space-x-4 justify-center bg-gray-100 rounded-b',

                iconWrapper:
                    'bg-gray-100 flex flex-shrink-0 h-12 items-center justify-center rounded-full w-12 mx-auto',
                icon: 'w-6 h-6 text-gray-500',
                content: 'w-full flex justify-center flex-col',

                titleWrapper: '',
                title: 'text-lg font-semibold text-center',

                textWrapper: 'text-left w-full',
                text: '',

                cancelButton:
                    'block px-4 py-2 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm hover:bg-gray-100 focus:border-gray-100 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs',
                okButton:
                    'block px-4 py-2 text-white transition duration-100 ease-in-out bg-green-500 border border-transparent rounded shadow-sm hover:bg-green-600 focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs',

                inputWrapper: 'mt-3 flex items-center space-x-3',

                input: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full',
                select: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50  disabled:opacity-50 disabled:cursor-not-allowed w-full',

                radioWrapper: 'flex items-center space-x-2',
                radio: 'text-green-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
                radioText: '',

                checkboxWrapper: 'flex items-center space-x-2',
                checkbox:
                    'text-green-500 transition duration-100 ease-in-out border-gray-300 rounded shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
                checkboxText: '',

                errorMessage: 'text-red-500 block text-sm',

                busyWrapper:
                    'absolute bg-opacity-50 bg-white flex h-full items-center justify-center left-0 top-0 w-full',
                busyIcon: 'animate-spin h-6 w-6 fill-current text-gray-500',

                overlayEnterClass: 'opacity-0',
                overlayEnterActiveClass: 'transition ease-out duration-100',
                overlayEnterToClass: 'opacity-100',
                overlayLeaveClass: 'opacity-100',
                overlayLeaveActiveClass: 'transition ease-in duration-75',
                overlayLeaveToClass: 'opacity-0',

                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: '',
            },
        },
    },
    't-badge': {
        component: TBadge,
        props: {
            variants: {
                default: 'bg-gray-200 text-gray-800',
                success: 'bg-green-100 text-green-800',
                error: 'bg-red-100 text-red-800',
                warning: 'bg-yellow-100 text-yellow-800',
                info: 'bg-blue-100 text-blue-800',
                pending: 'bg-orange-100 text-orange-800',
            },
        },
    },
};
